import { useQuery, UseQueryResult } from "@tanstack/react-query";

import {
  SmartEngineRun,
  SmartEngineRunSearchParams,
  SmartEngineRunSummary,
  SearchSmartEngineRunsResponse,
  getSmartEngineRun,
  searchSmartEngineRuns,
} from "./engine-run-api";

const DEFAULT_LIMIT = 25;

export interface UseSmartEngineRunsOptions extends SmartEngineRunSearchParams {
  enabled?: boolean;
}

export const useSmartEngineRuns = (
  options: UseSmartEngineRunsOptions
): UseQueryResult<SearchSmartEngineRunsResponse> => {
  const { enabled = true, limit, offset, ...filters } = options;

  return useQuery({
    queryKey: [
      "smart-engine-runs",
      {
        limit: limit ?? DEFAULT_LIMIT,
        offset: offset ?? 0,
        ...filters,
      },
    ],
    queryFn: () =>
      searchSmartEngineRuns({
        limit: limit ?? DEFAULT_LIMIT,
        offset: offset ?? 0,
        ...filters,
      }),
    enabled,
  });
};

export const useSmartEngineRun = (
  smartEngineRunId: string | null | undefined,
  { enabled = true }: { enabled?: boolean } = {}
): UseQueryResult<SmartEngineRun> => {
  return useQuery({
    queryKey: ["smart-engine-run", smartEngineRunId],
    queryFn: () => getSmartEngineRun(smartEngineRunId!),
    enabled: enabled && Boolean(smartEngineRunId),
  });
};

export type { SmartEngineRun, SmartEngineRunSummary };
